module.exports = __webpack_public_path__ + "static/media/MasterChengYen.0f4feee1.png";